// TODO: this might have to be moved to a common place where to access from the pages that need it.
import { getSdk } from "../services/sdkService";
import { i18n } from "../services/i18nService";
import { getUserMediaLists, checkHistoryProgress } from "../services/mediaListService";
import { getEpisodeLabel } from "../services/copyService";
import { isSuitableFor4KPlayback, getTrailer } from "../services/titleDataService";
import { redirectTo } from "../services/navigationService";
import isSeries from "../utils/isSeries";
import { routes } from "../routes";
import { DPLAY } from "../utils/epgUtil";
import { sendVideoPlayClickEventDataForBytePlus } from "../services/byteEventService";
import { getStreamingURL, isEnableNoDrm } from "../services/mediaService";
import { isFVODFreeToAir } from "./fvodUtils";
//import * as Sentry from "@sentry/browser";

let seasonsList;
let episodesList;
let lastEpisodeData;

const HISTORY_LIST = "historylist";
const WATCH_LIST = "watchlist";
export const STARZ = "starz";

/**
 * This method is used when reproducing content either from Layout or MyLibrary.
 */
export async function play(is4K, data, extra = {}) {
  const { id, progress, seriesId, moduleId, contentType, profileType } = this.videoConfig;
  if (this.playFromLabel === "cw_home") {
    redirectTo.call(this, routes.player, {
      playFrom: this.playFromLabel,
      videoConfig: { id, progress, seriesId, moduleId, is4K, contentType, profileType },
      ...extra
    });
  } else {
    const videoData = await getVideoData.call(this, id, progress, seriesId, moduleId, is4K, contentType, data);
    sessionStorage && sessionStorage.setItem("seriesPlaying4K", is4K);
    // Byte+ GA event for play click
    sessionStorage.setItem("currScreen2", sessionStorage.getItem("currentScreen"));
    sessionStorage.setItem("prevScreen2", sessionStorage.getItem("prevScreen"));
    if (videoData?.videoType === "series") {
      this.isSeries = true;
    }
    if (this.playFromLabel === "cw_my_library") {
      videoData.profileType = profileType;
      videoData.contentType = contentType;
    }
    sendVideoPlayClickEventDataForBytePlus({
      thisInstance: this,
      mediaData: videoData,
      currentScreen: sessionStorage?.getItem("currentScreen"),
      previousScreen: sessionStorage?.getItem("prevScreen")
    });
    this.state.didPlayerLaunch &&
      redirectTo.call(this, routes.player, {
        ...videoData,
        ...(this.playFromLabel && { playFrom: this.playFromLabel }),
        ...extra
      });
  }
}

/**
 * This method is used when reproducing content either from Layout or MyLibrary.
 */
export async function playHandler(data, extra) {
  if (isSuitableFor4KPlayback(this.videoConfig.titleId4K)) {
    this.setState({ modal4K: true }, () => {
      this.play4KModalFocusPath && this.play4KModalFocusPath.props.setFocus();
    });
  } else {
    this.props.pauseNavigation();
    this.setState({ didPlayerLaunch: true });
    play.call(this, false, data, extra);
  }
}

function getPlaybackTime(progress) {
  return progress.playbackTime || 0;
}

/**
 * Builds an object to be passed to the player with the Trailer for the selected title data.
 * @param {String} titleId  - Title (movie/episode) ID.
 * @param {Object} progress - Title (movie/episode) progress data.
 * @param {String} seriesId - Series ID.
 * @param {String} moduleId - Module ID for use it on send user events.
 * @param {String} is4K     - The quality is 4k.
 */
export async function getTrailerVideoData(titleId, moduleId, is4K, data = null) {
  let videoTitle = data;
  if (!videoTitle || is4K) {
    const sdk = await getSdk();
    videoTitle = await sdk.mediaManager.getTitle(titleId, { is4K });
  }
  videoTitle["manifest"] = await getTrailer(videoTitle);
  const {
    id,
    mediaContent,
    title,
    addonContent,
    manifest,
    has4K,
    shortDescription,
    description,
    tagList,
    isLive
  } = videoTitle;
  const videoType = isSeries(tagList["categories"]) ? "series" : "movie";
  const videoGenre = tagList["genres"] ? tagList.genres[0] : null;
  return {
    id,
    mediaContent,
    videoType,
    title,
    genre: videoGenre,
    description: shortDescription || description,
    manifest,
    addonContent,
    moduleId,
    has4K,
    isLive
  };
}
/**
 * Builds an object to be passed to the player with the watchlist selected title data.
 * This method is used when reproducing content either from Layout or MyLibrary.
 * @param {String} titleId  - Title (movie/episode) ID.
 * @param {Object} progress - Title (movie/episode) progress data.
 * @param {String} seriesId - Series ID.
 * @param {String} moduleId - Module ID for use it on send user events.
 * @param {String} is4K     - The quality is 4k.
 */
export async function getVideoData(
  titleId,
  progress,
  seriesId,
  moduleId,
  is4K,
  contentType,
  onlineContent,
  data = null
) {
  let videoTitle = data;
  const getModelDevice = await getSdk().systemManager.device.getRealModel();
  if (!videoTitle || is4K) {
    const sdk = await getSdk();
    videoTitle = await sdk.mediaManager.getTitle(titleId, { is4K });
  }
  const {
    id,
    mediaContent,
    title,
    shortDescription,
    description,
    tagList,
    tvSeasonEpisodeNumber,
    tvSeasonNumber,
    title4K,
    addonContent,
    isLive,
    config,
    adsCountryRights,
    assetTypes,
    images,
    ecommerceAds,
    ageRating,
    languages,
    contentOwnership: ownerShip,
    tags
  } = videoTitle;
  const videoType = isSeries(tagList["categories"]) ? "series" : "movie";
  const videoGenre = tagList["genres"] ? tagList.genres[0] : null;
  const has4K = is4K && !!title4K;
  const media = has4K ? title4K.mediaContent[0] : mediaContent[0];
  const video = media.content.video;
  const noDrmConfig = config;
  const streamingData = getStreamingURL(adsCountryRights, ecommerceAds, noDrmConfig, media?.content.video);
  const contentOwnership = ownerShip && ownerShip.length > 0 ? ownerShip[0] : STARZ;
  const isFVOD = isFVODFreeToAir(tags);
  return {
    addonContent,
    isLive,
    videoType,
    title,
    contentOwnership,
    genre: videoGenre,
    contentTypeYoubora: videoType,
    contentType: isFVOD ? "FVOD" : contentType,
    onlineContent: onlineContent,
    description: shortDescription || description,
    manifest: streamingData?.streamingUrl || video.streamingUrl,
    releasePid: streamingData?.releasePid || video.releasePid,
    releaseUrl: streamingData?.releaseUrl || video.releaseUrl,
    duration: streamingData?.duration || video.duration,
    dash_widevine_ads: streamingData,
    adsCountryRights,
    dPlay: config?.dPlay || "",
    isEnableNoDrm: isEnableNoDrm(adsCountryRights, config, media?.content.video) || false,
    filmstrip: media.content.filmstrip,
    playbackTime: progress && getPlaybackTime(progress),
    id,
    moduleId,
    has4K,
    assetTypes,
    genres: tagList["genres"] ? tagList.genres : null,
    backgroundCover: images?.hero || null,
    isEnableVideoCommerce: ecommerceAds || false,
    //externalSubtitles: has4K && media.content.subtitles,
    externalSubtitles: media.content.subtitles,
    mediaGuid: media.mediaGuid,
    content_language: languages && languages.length > 0 ? languages[0] : null,
    content_rating: ageRating,
    device_model: getModelDevice,
    credits: media.credits,
    ...(tvSeasonEpisodeNumber &&
      tvSeasonNumber && {
        tvSeasonEpisodeNumber,
        tvSeasonNumber,
        episodeLabel: getEpisodeLabel(tvSeasonNumber, tvSeasonEpisodeNumber),
        seriesId
      }),
    enforceAds: config?.enforceAds || false
  };
}

/**
 * Gets series general data and builds an object to be passed to the player about
 * its seasons and episodes information.
 * @param {String} seriesId - Series ID.
 * @param {Boolean} needsLastEpisodeData.
 */
export async function getSeasonsAndEpisodesList(seriesId, needsLastEpisodeData) {
  await getSeasons(seriesId);
  return {
    episodesList: await getEpisodes(seriesId),
    seasonsList: recheckSeasonsEpisodes(formatSeasonsNumber(seasonsList), episodesList),
    ...(needsLastEpisodeData && { lastEpisode: lastEpisodeData })
  };
}

/**
 * Checks series seasons list once episodes list is retrieved to make sure to get all seasons
 * that have episodes related.
 * @param {Array} seasonsList - Array containing all seasons, formatted.
 * @param {Array} episodesList - Array containing all episodes.
 */
export function recheckSeasonsEpisodes(seasonsList, episodesList) {
  let formattedSeasonList = [];
  if (seasonsList && seasonsList.length && episodesList && episodesList.length) {
    for (let formattedSeason of seasonsList) {
      episodesList.find(episode => episode.tvSeasonNumber === formattedSeason.number) &&
        formattedSeasonList.push(formattedSeason);
    }
    return formattedSeasonList;
  }
  return seasonsList;
}

/**
 * Gets and formats seasons list to be passed to the player.
 * @param {String} seriesId - Series ID.
 */
async function getSeasons(seriesId) {
  const sdk = await getSdk();
  try {
    const response = await sdk.mediaManager.getSeriesSeasonsList(seriesId);
    seasonsList = response.data ? response.data : response;
  } catch (e) {
    return [];
  }
}

/**
 * Format seasons list to be passed to the player.
 */
export function formatSeasonsNumber(seasonsObject) {
  const seasonsArray = [];
  for (let season of seasonsObject) {
    seasonsArray.push({
      title: `${i18n.get("global.media.season")} ${season.tvSeasonNumber}`,
      number: season.tvSeasonNumber
    });
  }
  return seasonsArray;
}

/**
 * Gets all seasons episodes and checks if series has ever been watched to inject data from historyList.
 * @param {String} seriesId - seriesId
 */
async function getEpisodes(seriesId) {
  episodesList = await getEpisodesData(seriesId, seasonsList);
  return await getUserMediaLists(seriesId, checkMediaListsData);
}

/**
 * Creates an array which gathers each and every episode of the series.
 * @param {String} titleId - Title ID.
 * @param {Array} seasonsList - Array of seasons objects.
 */
export async function getEpisodesData(titleId, seasonsList, country) {
  const sdk = await getSdk();
  const seasonsEpisodes = seasonsList.map(
    async season => await sdk.mediaManager.getSeriesSeasonEpisodes(titleId, season.tvSeasonNumber, country)
  );
  const episodesArray = await seasonsEpisodes.reduce(async (acc, curr) => {
    try {
      return (await acc).concat(await curr);
    } catch (e) {
      return (await acc).concat([]);
    }
  }, []);

  const episodesWithTags = includeEpisodesTags(episodesArray);
  return includeEpisodesDurationText(episodesWithTags);
}

/**
 * Includes an extra field providing the combination of its video content duration and the proper
 * time measurement label (in the app selected language) to every episode from the episodes array.
 * @param {Array} episodesArray - Episodes array.
 */
function includeEpisodesDurationText(episodesArray) {
  return episodesArray.map(episode => ({
    ...episode,
    ...(episode.mediaContent[0].content.video.duration && {
      durationText: `${Math.floor(episode.mediaContent[0].content.video.duration / 60)} ${i18n.get(
        "pages.detail.mins"
      )}`
    })
  }));
}

function includeEpisodesTags(episodesArray) {
  return episodesArray.map(episode => ({
    ...episode,
    tags: episode.tags || []
  }));
}

/**
 * Checks data present in mediaLists array.
 * If the title is in historylist but not in watchlist it means that this title has seen to the end
 * and the playback time should be 0 in order to start from the beggining
 * @param {Array} mediaLists - Array of media lists objects.
 */
function checkMediaListsData(mediaLists) {
  const historyList = mediaLists.filter(list => list.name === HISTORY_LIST);
  const watchList = mediaLists.filter(list => list.name === WATCH_LIST);
  const episodes =
    episodesList &&
    episodesList.length &&
    historyList.length &&
    checkHistoryProgress(episodesList, historyList[0].titles, watchList && watchList.length && watchList[0].titles);

  watchList && watchList.length && (lastEpisodeData = watchList[0].titles[0]);
  return episodes;
}
